<div [formGroup]="subForm">
  <div class="mt-3">
    <!--@if ((authService.isAdmin() | async) ) {-->
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
      for="label"><strong>{{variables.addChangeRemoveUsers}}</strong>
    </span>
    <!--}-->
    <!--@if (!((authService.isAdmin() | async))) {-->
    <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="!canEditCatalog"
      for="label"><strong>{{variables.catalogUsers}}</strong>
    </span>
    <!--}-->
    @if (listItem && listItem.length > 0) {
    <div class="list-group-control mt-3">
      <div class="d-flex list-group-control-header">
        <div class="list-group-control-header-name">{{variables.name}}</div>
        <div class="list-group-control-header-das">{{variables.email}}</div>
      </div>
      @for (item of listItem; track item) {
      <div class="list-group-control-item action_buttons">
        <div class="list-group-control-item-name">{{item.name}}</div>
        <div class="list-group-control-item-das">{{item.email}}</div>
        <div class="list-group-control-item-icons">
          <span *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog"
            (click)="openDialogEditProject(item)" class="icon-edit me-3 action_buttons-item"
            matTooltip="{{variables.editeUser}}">
            <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" width="20px">
          </span>

          <span *hasPermission="Permission.CATALOG_MANAGE" [showWhen]="canEditCatalog"
            matTooltip="{{variables.removeUser}}" (click)="openDialogRemove(item.email)"
            class="icon-close me-1 action_buttons-item">
            <img src="../../../../assets/svg/BinWhite.svg" alt="Bin Icon" width="15px">
          </span>
        </div>
      </div>
      }
    </div>
    }
    <br>
    @if (!listItem || listItem.length === 0) {
    <div class="mt-3"></div>
    }
    <!--@if ((authService.isAdmin() | async)) {-->
    <app-button *hasPermission="Permission.CATALOG_EDIT_CONFIG" [showWhen]="canEditCatalog" typeBtn="primary"
      class="addItemsInCatalogStepBtn" (click)="openDialogProject()" message="{{variables.addUser}}"></app-button>
    <!--}-->
  </div>
</div>